import { render } from "./GasSustain.vue?vue&type=template&id=d6b0a0a2&scoped=true"
import script from "./GasSustain.vue?vue&type=script&lang=js"
export * from "./GasSustain.vue?vue&type=script&lang=js"

import "./GasSustain.vue?vue&type=style&index=0&id=d6b0a0a2&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b0a0a2"]])

export default __exports__